export function dataInRequest(params = {}) {
  return {
    type: '@transferenciaAreiaSilo/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@transferenciaAreiaSilo/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@transferenciaAreiaSilo/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@transferenciaAreiaSilo/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@transferenciaAreiaSilo/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@transferenciaAreiaSilo/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@transferenciaAreiaSilo/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@transferenciaAreiaSilo/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@transferenciaAreiaSilo/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@transferenciaAreiaSilo/RECORD_FILTERING',
    payload: { params },
  };
}
